/**
 * Hamla SDK Loader Entry Point
 *
 * This is what merchants load via <script src="sdk.js">.
 * Rendering loads async via ChunkLoader.
 */

export const VERSION = '6.0.0';

// Main SDK
export { HamlaSDK } from './HamlaSDK';

// Types
export * from './types';

// Core
export { Logger } from './core/Logger';

// API
export * from './api';

// Orchestration (server-decided)
export * from './orchestration';

// Micro adapters (v6)
export * from './adapters';

// Push notifications
export { PushManager } from './push/PushManager';
export type {
  PushManagerConfig,
  PushStatus,
  PushPermission,
} from './push/PushManager';

// Live slots
export { LiveSlots } from './live-slots';
export type { LiveSlotDef, LiveCart } from './live-slots';

// Chunk loader (loads render chunk async)
export { ChunkLoader } from './chunk-loader';
export type { RenderModule } from './chunk-loader';

// NOTE: No rendering imports. Rendering loads via ChunkLoader.

// Carrying the visitor id on outbound links — see cross-domain.ts.
export { decorateUrl, shouldDecorate, VISITOR_URL_PARAM } from './cross-domain';
